import m from "mithril";
import i18n from "../../../shared/i18n/i18n";
import {ACTION_TYPES} from "../../values";
import Component_Unit_Action_SendEmail_Settings from "./component_unit_action_sendemail_settings";
import Unit_Courses from "../unit_courses";

let loading = false;
let tab = "settings";
let unit = null;

const Page_Unit_Action = {
    oninit: function (vnode) {
        unit = vnode.attrs.unit;
    },
    view: function () {
        return [
            m(".content-box", [
                m(".toolbar", {class: loading ? "disable-buttons" : ""}, [
                    m(".toolbar-section with-menu", [
                        m("h1", unit ? [
                            unit.properties.actionType === ACTION_TYPES.sendEmail ? i18n.t("send_email-action_unit")
                                : "unknown_action_unit_type"
                        ] : i18n.t("action_unit")),
                        m(".toolbar-menu", [
                            m("div", {
                                class: tab === "settings" ? "active" : "", onclick: function () { tab = "settings"; }
                            }, i18n.t("settings")),
                            m("div", {
                                class: tab === "courses" ? "active" : "", onclick: function () { tab = "courses"; }
                            }, i18n.t("courses"))
                        ])
                    ])
                ])
            ]),
            !loading ? [
                unit ? [
                    tab === "courses" ? m(Unit_Courses, {unitId: unit.properties.id})
                        : unit.properties.actionType === ACTION_TYPES.sendEmail ? m(Component_Unit_Action_SendEmail_Settings, {unit: unit.properties, onCoursesClick: function() { tab = "courses"; }})
                            : i18n.t("unknown_action_type")
                ] : m(".text-gray padding", i18n.t("unable_to_load_unit"))
            ] : m(".text-gray padding", [i18n.t("loading"), m(".loading-dots")])
        ];
    }
};
export default Page_Unit_Action;
